/**
 * @generated SignedSource<<e279c9e169972a9bac48e4eeb4dcf1b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesAssociatesContentTemplate_salesAssociate$data = {
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "SalesAssociatesContentTemplate_salesAssociate";
};
export type SalesAssociatesContentTemplate_salesAssociate$key = {
  readonly " $data"?: SalesAssociatesContentTemplate_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatesContentTemplate_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesAssociatesContentTemplate_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "b574f0f7a71cd9d9eead47364425fb03";

export default node;
